
import ConfigScene from '../../../helpers/ConfigScene';

class ItemBullet extends PIXI.Container {
  constructor(bllData) {
    super();

    // const
    this.LBL_TX_X = 23;
    this.LBL_TX_PAD_X = 16;
    this.LBL_W = 400;

    // vars
    this.hovered = false;
    this.bulletEnabled = false;
    this.isLeft = false; // label open type

    this.bllData = bllData;
    this.bllId = Number(this.bllData.id.split('_')[0]);
    this.hideGoal = 0;

    this.lblCont = null;
    this.lblBg = null;
    this.lblTx = null;
    this.lblMask = null;

    this.bllCont = null;
    this.bllBg = null;
    this.bllNum = null;

    this.initAnimDelay = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // props
    this.visible = false;
    this.x = this.bllData.iX + this.bllData.hint.hX;
    this.y = this.bllData.iY + this.bllData.hint.hY;

    if (this.x > 1100) {
      this.isLeft = true;
    }

    // parts
    this.setParts();

    // anim
    this.initAnim();

    // lsns
    aScene.signals.itemCall.add(this.itemCallFc, this);
  }

  // --------------------------------------------------------------
  // Init anim
  // --------------------------------------------------------------

  initAnim() {
    // show with delay
    this.initAnimDelay = setTimeout(() => {
      this.initAnimStart();
    }, 800 + (this.bllId * 100));
  }

  initAnimSkip() {
    clearTimeout(this.initAnimDelay);
  }

  initAnimStart() {
    this.showBullet(true);
    // hide with delay
    this.initAnimDelay = setTimeout(() => {
      this.initAnimEnd();
    }, 3000);
  }

  initAnimEnd() {
    this.showBullet(false);
  }

  // --------------------------------------------------------------
  // Set parts
  // --------------------------------------------------------------

  setParts() {
    this.setLabel();
    this.setBullet();
  }

  // --------------------------------------------------------------
  // Label
  // --------------------------------------------------------------

  setLabel() {
    this.lblCont = new PIXI.Container();
    this.lblCont.visible = false;
    this.addChild(this.lblCont);

    this.lblBg = new PIXI.Sprite.fromFrame('hint-tx-bg.png');
    this.lblCont.addChild(this.lblBg);
    this.lblBg.anchor.y = 0.5;

    this.lblTx = new PIXI.Text('', { font: `15px ${ConfigScene.FONT_BASE}`, fill: '#084d54' });
    if (this.isLeft) {
      this.lblTx.x = -this.LBL_TX_X;
      this.lblTx.anchor.x = 1.0;
    } else {
      this.lblTx.x = this.LBL_TX_X;
    }
    this.lblTx.y = -8;
    this.lblCont.addChild(this.lblTx);

    this.lblMask = new PIXI.Graphics();
    this.lblMask.beginFill(0x000000, 1.0);
    if (this.isLeft) {
      this.lblMask.drawRect(-this.LBL_W, -17, this.LBL_W, 34);
    } else {
      this.lblMask.drawRect(0, -17, this.LBL_W, 34);
    }
    this.lblMask.endFill();
    this.addChild(this.lblMask);
    this.lblCont.mask = this.lblMask;

    this.setLabelTx(aScene.daysInfoArr[this.bllId].title1);
    if (!aPage.features.isAppOpen(aScene.daysInfoArr[this.bllId])) {
      this.setLabelTx(aScene.daysInfoArr[this.bllId].alt.title1);
    }
  }

  setLabelTx(txt) {
    // set
    this.lblTx.text = txt.replace(/\n/g, ' ');
    this.lblTx.updateText();
    // update elements
    if (this.isLeft) {
      this.lblBg.x = -this.lblTx.width - this.LBL_TX_X - this.LBL_TX_PAD_X;
    } else {
      this.lblBg.x = -this.LBL_W + this.lblTx.width + this.LBL_TX_X + this.LBL_TX_PAD_X;
    }
    // anim value
    this.hideGoal = this.lblTx.width + this.LBL_TX_X + this.LBL_TX_PAD_X;
    if (!this.isLeft) {
      this.hideGoal *= -1;
    }
  }

  showLabel(doShow) {
    if (doShow) {
      // show
      this.lblCont.visible = true;
      this.killLabelAnim();

      this.lblCont.x = this.hideGoal;
      this.lblCont.alpha = 0.0;
      TweenMax.to(this.lblCont, 0.25, {
        x: 0,
        alpha: 1.0,
        delay: 0.1,
        ease: Sine.easeOut,
      });
    } else {
      // hide
      this.killLabelAnim();
      TweenMax.to(this.lblCont, 0.2, {
        x: this.hideGoal,
        alpha: 0.0,
        ease: Sine.easeIn,
        onComplete: this.labelAnimEnd,
        onCompleteScope: this,
      });
    }
  }

  killLabelAnim() {
    TweenMax.killTweensOf(this.lblCont);
  }

  labelAnimEnd() {
    this.lblCont.visible = false;
  }

  // --------------------------------------------------------------
  // Bullet
  // --------------------------------------------------------------

  setBullet() {
    this.bllCont = new PIXI.Container();
    this.addChild(this.bllCont);

    this.bllBg = new PIXI.Sprite.fromFrame('hint-blt-bg.png');
    this.bllCont.addChild(this.bllBg);
    this.bllBg.anchor.x = 0.5;
    this.bllBg.anchor.y = 0.5;

    this.bllNum = new PIXI.Text(String(this.bllId + 1), {
      font: `16px ${ConfigScene.FONT_BASE}`,
      fill: '#ffffff',
    });
    this.bllNum.anchor.x = 0.5;
    this.bllNum.anchor.y = 0.5;
    this.bllCont.addChild(this.bllNum);

    // touch interactivity
    if (aPage.features.isTouch) {
      this.interactive = true;
      this.on('pointerdown', () => {
        if (this.hovered) {
          aScene.itemsHelper.trySelectItem();
        }
      });
    }
  }

  showBullet(doShow) {
    if (doShow && !this.bulletEnabled) {
      // show
      this.bulletEnabled = true;
      this.visible = true;
      this.killBulletAnim();

      this.bllCont.alpha = 0.0;
      TweenMax.to(this.bllCont, 0.3, { alpha: 1.0 });

      this.bllCont.scale.x = 0.4;
      this.bllCont.scale.y = 0.4;
      TweenMax.to(this.bllCont.scale, 0.3, { x: 1.0, y: 1.0, ease: Back.easeOut });
    } else if (!doShow && this.bulletEnabled && !aScene.itemsHelper.helpBullets) {
      this.bulletEnabled = false;
      // hide
      this.killBulletAnim();
      TweenMax.to(this.bllCont, 0.2, { alpha: 0.0, delay: 0.1 });
      TweenMax.to(this.bllCont.scale, 0.2, {
        x: 0.2,
        y: 0.2,
        delay: 0.1,
        ease: Sine.easeIn,
        onComplete: this.bulletAnimEnd,
        onCompleteScope: this,
      });
    }
  }

  killBulletAnim() {
    TweenMax.killTweensOf(this.bllCont);
    TweenMax.killTweensOf(this.bllCont.scale);
  }

  bulletAnimEnd() {
    this.visible = false;
  }

  // --------------------------------------------------------------
  // Lsn
  // --------------------------------------------------------------

  itemCallFc(sgType, optParams) {
    switch (sgType) {
      case ConfigScene.E_ITEM_BULLET_SWITCH:
        this.initAnimSkip();
        this.showBullet(aScene.itemsHelper.helpBullets);
        break;
      case ConfigScene.E_ITEM_HOVER:
        if (!aPage.isArchive) {
          if (optParams === this.bllId) {
            this.setHoverState(true);
          } else {
            this.setHoverState(false);
          }
        }
        break;
      default:
    }
  }

  // --------------------------------------------------------------
  // Show/Hide
  // --------------------------------------------------------------

  setHoverState(doHover) {
    if (doHover && !this.hovered) {
      this.doHover(true);
    } else if (!doHover && this.hovered) {
      this.doHover(false);
    }
  }

  doHover(hover) {
    this.hovered = hover;
    this.initAnimSkip();
    this.showBullet(hover);
    this.showLabel(hover);
  }
}

export default ItemBullet;



// WEBPACK FOOTER //
// ./src/js/scene/parts/town/parts/ItemBullet.js